import Promise from 'bluebird'
import request from 'superagent'
import utils from '../utils'
import config from "./config"

const loadCurrentUser = function() {
	if (typeof localStorage != 'undefined' && localStorage.currentSession) {
		try {
			let user = JSON.parse(decodeURIComponent(escape(window.atob( localStorage.currentSession ))))
			if (user.uid) {
				if (typeof window) {
					window.mixpanel.identify(user.uid)
				}
				return user
			}
			return {}
		} catch(e) {
			console.error("couldn't decode login info from local storage", e);
			return {}
		}
	} else {
		return {}
	}
}

var appUrl = config.appUrl
var currentSession = loadCurrentUser()

export function isLogin() {
	return !!(currentSession && currentSession.uid)
}

export function post(url, variables, data, success, error) {
	console.log("About to send " + url);
	console.log(currentSession)
	if(typeof document == "undefined") {
		return new Promise(() => {})
	}
	return new Promise((resolve, reject) => {
		var req = request
		.post(appUrl + url)
		.send({variables : variables, data : data})
		.set('Accept', 'application/json')
		if(currentSession.token) {
			req = req.set('Authorization', 'BEARER ' + currentSession.token )
		}
		req.end((err, res) => {
			if (res && res.ok) {
				resolve(utils.safeParse(res.text))
				if(success) {
					success(utils.safeParse(res.text))
				}
			} else {
				reject(err)
				if (error) {
					error(err)
				}
			}
		})
	})
}

export function login(login, pwd) {
	if(typeof document == "undefined") {
		return new Promise(() => {})
	}
	
	return new Promise((resolve, reject) => {
		request
		.post(appUrl + "/ls_login")
		.type('form')
		.send({username:login, password : pwd})
		.end((err, res) => {
			console.log(err, res)
			if(err || res.status == 401) {
				currentSession = {}
				if (typeof localStorage != 'undefined') {
					localStorage.currentSession = window.btoa(unescape(encodeURIComponent( JSON.stringify({}) )))
				}
				reject(err || res.status)
			} else {
				let user = utils.safeParse(res.text)
				currentSession = {
					login:user.login,
					token :user.token,
					uid :user.uid
				}
				if (typeof window) {
					window.mixpanel.identify(currentSession.uid)
					window.mixpanel.people.set({
						"$first_name": user.user.firstname,
						"$last_name": user.user.lastname,
						"$email": user.user.login,
						"$created": user.user.date_cre,
						"account_id": user.user.account_id,
						"accounttype": user.user.accounttype,
						"lang": user.user.userlang || "fr",
						"title": user.user.title,
						"role": user.user.role,
						"position": user.user.position,
						"xp": user.user.xp
					})
				}
				if (typeof localStorage != 'undefined') {
					localStorage.currentSession = window.btoa(unescape(encodeURIComponent( JSON.stringify(currentSession) )))
				}
				resolve(currentSession)
			}
		})
	})
}
export function logout() {
	if(typeof document == "undefined") {
		return new Promise(() => {})
	}
	
	return new Promise((resolve, reject) => {
		request
		.post(appUrl + "/ls_logout")
		.type('form')
		.send({})
		.end((err, res) => {
			console.log(err, res)
			if (typeof localStorage != 'undefined') {
				localStorage.currentSession = window.btoa(unescape(encodeURIComponent( JSON.stringify({}) )))
			}
			currentSession = loadCurrentUser()
			
			if(err || res.status == 401) {
				reject(err || res.status)
			} else {
				resolve({})
			}
		})
	})
}

export function pwdreminder(email) {
	return post('/littleshooting/public/pwdreminder', {email:email})
}

export function createUser(info) {
	return post("/api/public/subscribeUser", {ls: true}, info).then(() => login(info.email, info.password))
}

export function saveStripeToken(token) {
	return post("/littleshooting/saveStripeToken", token)
}

export function listOffers() {
	return post("/littleshooting/public/listOffers")
}

export function purchase(offers, contact, token, delivery, message) {
	return post("/littleshooting/purchase", {}, {offers, contact, token, delivery, message})
}

export function saveContact_form(contact) {
	return post("/littleshooting/saveContact_form", {}, contact)
}

export function isLoginCheck() {
	return post("/littleshooting/testConnect")
}

export function loadBillingContact() {
	return post("/littleshooting/loadBillingContact")
}

export function loadUser() {
	return post("/littleshooting/loadUser")
}


export function saveBillingContact(contact) {
	return post("/littleshooting/saveBillingContact", {}, contact)
}

export function saveUserInfo(contact) {
	return post("/littleshooting/saveUserInfo", {}, contact)
}

export function listOrders() {
	return post("/littleshooting/listOrders")
}


// WEBPACK FOOTER //
// ./src/actions/actions.js